import { useCallback, useState } from "react";
import { deepMerge } from "@therms/web-js";
//#region src/hooks/useSetState.ts
var useSetState = (initialState = {}) => {
	const [state, set] = useState(initialState);
	return [state, useCallback((patch, opts = { merge: true }) => {
		set((prevState) => patch instanceof Function ? Object.assign({}, patch(prevState)) : opts?.merge ? deepMerge({}, prevState, patch) : patch);
	}, [])];
};
//#endregion
export { useSetState };

//# sourceMappingURL=useSetState.js.map